import { css } from "@emotion/react";
import lottie_loading from "@src/assets/lottie_loading_deungi.json";
import { IssueLandRegisterResponseDto, useIssueLandRegister } from "@src/hooks/landRegister/useLandRegister";
import { useFindOneUserSubsInfo } from "@src/hooks/user/userApi";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LAND_REGISTER_ERROR_MODAL_TYPE, LAND_REGISTER_MAX_REQUEST_ERROR_MESSAGE } from "./LandRegisterMain";
import ConfirmModal from "@src/components/popup/ConfirmModal";
import { transferToNative } from "@src/lib/WebAppBridge";

// 필지, 매물 상세 등의 페이지에서 토지•임야대장 열람 버튼 클릭 > 바로 발급 받는 경우
const LandRegisterIssueWaiting = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedFieldPnu = searchParams.get("pnu");
    const [errorMessage, setErrorMessage] = useState("");
    const [isOpenConfirmModal, setIsOpenConfirmModal] = useState<LAND_REGISTER_ERROR_MODAL_TYPE>(
        LAND_REGISTER_ERROR_MODAL_TYPE.닫기,
    );

    const { mutate: issueLandRegister } = useIssueLandRegister();

    const goToIssueStatusPage = (issued: IssueLandRegisterResponseDto) => {
        navigate({
            pathname: "/landRegister/status",
            search: `?id=${issued._id}&address=${issued.address}`,
        });
    };

    const handleConfirm = () => {
        transferToNative("done", "closeWebView");
        if (errorMessage.includes("상품권")) {
            localStorage.setItem(
                "selectedLandRegister",
                JSON.stringify({
                    pnu: selectedFieldPnu,
                }),
            );
            navigate("/landRegister/payment?inflow=1");
        }
        setIsOpenConfirmModal(LAND_REGISTER_ERROR_MODAL_TYPE.닫기);
    };

    const [errorTitle, setErrorTitle] = useState("");

    useEffect(() => {
        if (selectedFieldPnu === null) return;

        issueLandRegister(
            { pnu: selectedFieldPnu },
            {
                onSuccess: (data) => goToIssueStatusPage(data),
                onError: (error) => {
                    setErrorMessage(error.message);
                    setIsOpenConfirmModal(LAND_REGISTER_ERROR_MODAL_TYPE.발급실패);
                },
            },
        );
    }, []);

    return (
        <div css={rootBoxStyle}>
            <div css={LoadingBoxStyle}>
                <div>
                    <span>발급 등록중...</span>
                    <Lottie className="lottie" animationData={lottie_loading} />
                </div>
            </div>

            {isOpenConfirmModal === LAND_REGISTER_ERROR_MODAL_TYPE.발급실패 && (
                <ConfirmModal
                    resultMessage={
                        <>
                            <p css={dialogTitle}>{errorTitle}</p>
                            <p css={dialogTitleStyle}>{errorMessage}</p>
                        </>
                    }
                    onConfirm={handleConfirm}
                    onCancel={() => {
                        localStorage.removeItem("selectedLandRegister");
                        setIsOpenConfirmModal(LAND_REGISTER_ERROR_MODAL_TYPE.닫기);
                        transferToNative("done", "closeWebView");
                    }}
                    buttonText={errorMessage.includes("상품권") ? "충전하기" : "확인"}
                    cancelText="닫기"
                />
            )}
        </div>
    );
};

export default LandRegisterIssueWaiting;

const rootBoxStyle = css`
    background-color: transparent;
`;

const LoadingBoxStyle = css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.55);
    animation: fadeIn 0.2s ease;
    z-index: 5;

    & > div {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        width: 100%;
        height: fit-content;
        top: 0;
        bottom: 0;
        margin: auto;

        .lottie {
            width: 100px;
        }
        & > span {
            color: #fff;
            font-size: 22px;
        }
    }
`;

const dialogTitleStyle = css`
    color: #0c002c;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
`;

const dialogContentStyle = css`
    color: #0c002c;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    margin: 8px 0 18px;
    word-break: break-word;
`;

const dialogTitle = css`
    color: #0c002c;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin: 0px 0 14px;
`;
